// Function to clean up subscribe-save modules from cart areas
function cleanupCartSliderModules() {
  // Remove any subscribe-save modules that might have been injected into cart areas
  const cartAreas = [
    '.recommend-products-slider',
    '.shipping-calculator', 
    '[data-drawer="cart"]',
    '.drawer-cart',
    '#cart-drawer',
    '.cart-recommended-products',
    '.cart-cross-sell'
  ];
  
  cartAreas.forEach(selector => {
    const cartArea = document.querySelector(selector);
    if (cartArea) {
      const subscribeModules = cartArea.querySelectorAll('.subscribe-save-module');
      subscribeModules.forEach(module => {
        module.remove();
      });
      
      // Also restore original product-card__info if it was replaced
      const productCards = cartArea.querySelectorAll('.product-card');
      productCards.forEach(card => {
        const infoSection = card.querySelector('.product-card__info');
        if (infoSection && !infoSection.querySelector('.product-card__price')) {
        }
      });
    }
  });
}

function resetSubscribeProcessing() {
  // Remove all data-subscribe-processed attributes to allow reprocessing if needed
  document.querySelectorAll('[data-subscribe-processed]').forEach(card => {
    card.removeAttribute('data-subscribe-processed');
  });
}

async function injectSubscribeSave() {
  if (!window.template || window.template.suffix !== 'subscription-collection') return;

  cleanupCartSliderModules();
  
  for (const card of document.querySelectorAll('.product-card')) {
    // Check if card has already been processed or has a module
    if (card.hasAttribute('data-subscribe-processed') || card.querySelector('.subscribe-save-module')) {
      continue;
    }
    
    // Mark this card as processed
    card.setAttribute('data-subscribe-processed', 'true');
    
    // detection for cart recommended products slider
    const isInCartSlider = 
      // Check if card is inside recommend-products-slider container
      card.closest('.recommend-products-slider') ||
      // Check if card has product-cart-slider class
      card.classList.contains('product-cart-slider') ||
      // Check if card is inside a swiper-slide within recommend-products-slider
      (card.closest('.swiper-slide') && card.closest('.recommend-products-slider')) ||
      // Check if card has cart-product-recommend-slider class
      Array.from(card.classList).some(className => className.includes('cart-product-recommend-slider')) ||
      // Check if card is inside drawer cart area
      card.closest('[data-drawer="cart"]') ||
      card.closest('.drawer-cart') ||
      card.closest('#cart-drawer') ||
      card.closest('.shipping-calculator') ||
      card.closest('.cart-recommended-products') ||
      card.closest('.cart-cross-sell');
    
    if (isInCartSlider) {
      continue;
    }
    
    const infoSection = card.querySelector('.product-card__info');
    if (!infoSection) continue;

    let productId = null;
    
    productId = card.getAttribute('data-product-id');
    
    if (!productId) {
      const keyAttr = card.getAttribute('key');
      if (keyAttr) {
        productId = keyAttr;
      }
    }
    
    if (!productId) {
      const productAttr = card.getAttribute('product');
      if (productAttr) {
        try {
          const productData = JSON.parse(productAttr);
          if (productData && productData.id) {
            productId = productData.id.toString();
          }
        } catch (e) {
          // Product attribute parsing failed
        }
      }
    }
    
    if (!productId && card.__vue__ && card.__vue__.product) {
      productId = card.__vue__.product.id?.toString();
    }
    

    
    if (!productId) {
      continue;
    }
    
    const productData = card.getAttribute('product');
    
    let product;
    let hasSubscription = false;
    let intervals = [];
    
    // First try to get intervals from global props if available
    if (window.__SUBSCRIBE_SAVE_PROPS__ && window.__SUBSCRIBE_SAVE_PROPS__[productId]) {
      intervals = window.__SUBSCRIBE_SAVE_PROPS__[productId].intervals;
    }
    
    // Try to get intervals from Vue component first (most reliable source)
    if (card.__vue__ && card.__vue__.product && card.__vue__.product.selling_plan_groups) {
      const vueProduct = card.__vue__.product;
      hasSubscription = true;
      
      // Extract intervals from Vue component's selling plan groups
      for (const sellingPlanGroup of vueProduct.selling_plan_groups) {
        if (sellingPlanGroup.selling_plans && sellingPlanGroup.selling_plans.length > 0) {
          intervals = sellingPlanGroup.selling_plans.map(plan => {
            if (plan.name) {
              // Convert plan names to interval format
              const dayMatch = plan.name.match(/(\d+)\s*days?/i);
              if (dayMatch) {
                return `${dayMatch[1]} Days`;
              }
              
              const weekMatch = plan.name.match(/(\d+)\s*weeks?/i);
              if (weekMatch) {
                return `${parseInt(weekMatch[1]) * 7} Days`;
              }
              
              const monthMatch = plan.name.match(/(\d+)\s*months?/i);
              if (monthMatch) {
                return `${parseInt(monthMatch[1]) * 30} Days`;
              }
              
              return plan.name;
            }
            return null;
          }).filter(Boolean); // Remove null values
          
          if (intervals.length > 0) break;
        }
        
        // Fallback: try options approach
        if (intervals.length === 0 && sellingPlanGroup.options && sellingPlanGroup.options.length > 0) {
          for (const option of sellingPlanGroup.options) {
            if (option.name && (
              option.name.toLowerCase().includes('delivery') || 
              option.name.toLowerCase().includes('interval') ||
              option.name.toLowerCase().includes('frequency')
            )) {
              if (option.values && option.values.length > 0) {
                intervals = option.values.map(value => {
                  if (typeof value === 'string') {
                    const dayMatch = value.match(/(\d+)\s*days?/i);
                    if (dayMatch) {
                      return `${dayMatch[1]} Days`;
                    }
                    
                    const weekMatch = value.match(/(\d+)\s*weeks?/i);
                    if (weekMatch) {
                      return `${parseInt(weekMatch[1]) * 7} Days`;
                    }
                    
                    const monthMatch = value.match(/(\d+)\s*months?/i);
                    if (monthMatch) {
                      return `${parseInt(monthMatch[1]) * 30} Days`;
                    }
                  }
                  return value;
                });
                break;
              }
            }
          }
          if (intervals.length > 0) break;
        }
      }
    }
    
    // If still no intervals, try to fetch from Shopify API
    if (intervals.length === 0 && !hasSubscription) {
      try {
        // Try to get product handle from the card
        const productHandle = card.querySelector('a[href*="/products/"]')?.href?.match(/\/products\/([^\/\?]+)/)?.[1];
        
        if (productHandle) {
          const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
          const productData = await response.json();
          
          if (productData.selling_plan_groups && productData.selling_plan_groups.length > 0) {
            hasSubscription = true;
            const group = productData.selling_plan_groups[0];
            
            if (group.selling_plans && group.selling_plans.length > 0) {
              intervals = group.selling_plans.map(plan => {
                if (plan.name) {
                  const dayMatch = plan.name.match(/(\d+)\s*days?/i);
                  if (dayMatch) {
                    return `${dayMatch[1]} Days`;
                  }
                  return plan.name;
                }
                return null;
              }).filter(Boolean);
            }
          }
        }
              } catch (e) {
          // API fetch failed, continue with fallback intervals
        }
    }
    
    // If no intervals found from any source, use fallback
    if (intervals.length === 0) {
      if (window.__SUBSCRIBE_SAVE_PROPS__ && window.__SUBSCRIBE_SAVE_PROPS__[productId]) {
        intervals = window.__SUBSCRIBE_SAVE_PROPS__[productId].intervals;
      } else {
        intervals = ['45 Days', '60 Days', '75 Days', '90 Days', '120 Days'];
      }
    }
    

    
    if (!hasSubscription) {
      continue;
    }
        
    const priceEl = infoSection.querySelector('.product-card__price');
    const ratingEl = infoSection.querySelector('.product-card__review-rating');
    if (priceEl) priceEl.remove();
    if (ratingEl) ratingEl.remove();
    let price = priceEl ? priceEl.textContent.replace(/[^\d.]/g, '').trim() : '';
    let compareAtPrice = price;
    if (price) {
                price = (parseFloat(price) * 0.8).toFixed(2);
    }
    const module = document.createElement('div');
    module.className = 'subscribe-save-module';
    

    
    const selectedInterval = intervals[0] || '45 Days';
    
    const optionsHtml = intervals.map(interval => `
      <option value="${interval}"${interval === selectedInterval ? ' selected' : ''}>every ${interval}</option>
    `).join('');
    
    module.innerHTML = `
      <div class="subscribe-save-dropdown-wrap">
      <select class="subscribe-dropdown">
          ${optionsHtml}
      </select>
      </div>
      <button class="subscribe-btn">
        <span class="subscribe-btn-label">SUBSCRIBE</span>
        <span class="subscribe-btn-prices">
          $${price} <span class="compare-at">$${compareAtPrice}</span>
        </span>
      </button>
    `;
    infoSection.prepend(module);

    const subscribeBtn = module.querySelector('.subscribe-btn');
    const dropdown = module.querySelector('.subscribe-dropdown');
    subscribeBtn.addEventListener('click', async function(e) {
      e.preventDefault();
      if (!productId) return alert('Product ID not found');
      const interval = dropdown.value.replace('Every: ', '');
      subscribeBtn.disabled = true;
      subscribeBtn.textContent = 'ADDING...';
      
      const vueComponent = card.__vue__;
      let variantId = productId;
      
      if (vueComponent && vueComponent.activeVariant && vueComponent.activeVariant.id) {
        variantId = vueComponent.activeVariant.id;
      } else {
      }
      
      // First, we need to get the product data to find the selling plan
      // This will allow us to add the item with a selling plan instead of just properties
      let sellingPlanId = null;
      
      try {
        // Try to get product data from Vue component first
        if (vueComponent && vueComponent.product && vueComponent.product.selling_plan_groups) {
          const product = vueComponent.product;
          for (const sellingPlanGroup of product.selling_plan_groups) {
            if (sellingPlanGroup.selling_plans && sellingPlanGroup.selling_plans.length > 0) {
              // Find the selling plan that matches the selected interval
              for (const plan of sellingPlanGroup.selling_plans) {
                if (plan.name && plan.name.toLowerCase().includes(interval.toLowerCase().replace(' days', ''))) {
                  sellingPlanId = plan.id;
                  break;
                }
              }
              if (sellingPlanId) break;
            }
          }
        }
        
        // If we couldn't find it from Vue component, try to fetch from product API
        if (!sellingPlanId) {
          // Try to get product handle from various sources
          let productHandle = null;
          
          // Check if we have the product data in the Vue component
          if (vueComponent && vueComponent.product && vueComponent.product.handle) {
            productHandle = vueComponent.product.handle;
          }
          
          // Check if we have it in the product attribute
          if (!productHandle && card.getAttribute('product')) {
            try {
              const productData = JSON.parse(card.getAttribute('product'));
              if (productData && productData.handle) {
                productHandle = productData.handle;
              }
            } catch (e) {
              // Product attribute parsing failed
            }
          }
          
          // If we still don't have it, try to construct from product ID
          if (!productHandle) {
            // We'll need to make a different approach since we don't have the handle
          } else {
            const productResponse = await fetch(`/products/${productHandle}.js`);
            if (productResponse.ok) {
              const productData = await productResponse.json();
              const variant = productData.variants.find(v => v.id == variantId);
              if (variant && variant.selling_plan_allocations) {
                
                // Since the allocations don't have names, we need to fetch selling plan details
                // Try to get selling plan names from the selling_plan_groups
                let sellingPlanNames = [];
                if (productData.selling_plan_groups && productData.selling_plan_groups.length > 0) {
                  
                  // Extract all selling plan names from groups
                  productData.selling_plan_groups.forEach(group => {
                    if (group.selling_plans) {
                      group.selling_plans.forEach(plan => {
                        sellingPlanNames.push({
                          id: plan.id,
                          name: plan.name,
                          delivery_policy: plan.delivery_policy
                        });
                      });
                    }
                  });
                }
                
                // Try to match by selling plan names from groups
                for (const planInfo of sellingPlanNames) {
                  
                  let isMatch = false;
                  const planName = planInfo.name.toLowerCase();
                  const intervalLower = interval.toLowerCase();
                  
                  // Strategy 1: Direct interval match (e.g., "45 Days" matches "45")
                  if (planName.includes(intervalLower.replace(' days', ''))) {
                    isMatch = true;
                  }
                  
                  // Strategy 2: Check if plan name contains the number from interval
                  const intervalNumber = intervalLower.match(/(\d+)/);
                  if (intervalNumber && planName.includes(intervalNumber[1])) {
                    isMatch = true;
                  }
                  
                  // Strategy 3: Check for common interval patterns
                  if (intervalLower.includes('45') && (planName.includes('45') || planName.includes('45-day') || planName.includes('45 day'))) {
                    isMatch = true;
                  }
                  if (intervalLower.includes('60') && (planName.includes('60') || planName.includes('60-day') || planName.includes('60 day'))) {
                    isMatch = true;
                  }
                  if (intervalLower.includes('90') && (planName.includes('90') || planName.includes('90-day') || planName.includes('90 day'))) {
                    isMatch = true;
                  }
                  
                  if (isMatch) {
                    // Find the allocation that matches this selling plan ID
                    const matchingAllocation = variant.selling_plan_allocations.find(a => a.selling_plan_id === planInfo.id);
                    if (matchingAllocation) {
                      sellingPlanId = planInfo.id;
                      break;
                    }
                  }
                }
                
                // Fallback: If no name match, try to use the first available selling plan
                // This ensures we get a discount even if the naming doesn't match exactly
                if (!sellingPlanId && variant.selling_plan_allocations.length > 0) {
                  const firstAllocation = variant.selling_plan_allocations[0];
                  sellingPlanId = firstAllocation.selling_plan_id;
                  
                  // Try to find the name from our selling plan names array
                  const fallbackPlan = sellingPlanNames.find(p => p.id === sellingPlanId);
                  const fallbackPlanName = fallbackPlan ? fallbackPlan.name : 'Unknown';
                }
              }
            }
          }
        }
              } catch (error) {
          // Could not fetch selling plan, will use properties fallback
        }

      // Create cart data with selling plan for proper discount handling
      let cartData;
      if (sellingPlanId) {
        // Use selling plan for proper discount handling
        cartData = {
          id: variantId,
          quantity: 1,
          sellingPlanId: sellingPlanId
        };
      } else {
        // Fallback to properties only (this won't show discounts on checkout)
        cartData = {
        id: variantId,
        quantity: 1
      };
      }

      if (window.cart && typeof window.cart.add === 'function') {
        window.cart.add([cartData]).then((response) => {
          if (response.status === 422) {
            subscribeBtn.innerHTML = `
              <span class="subscribe-btn-label">ERROR</span>
              <span class="subscribe-btn-prices">
                $${price} <span class="compare-at">$${compareAtPrice}</span>
              </span>
            `;
            setTimeout(() => {
              subscribeBtn.innerHTML = `
                <span class="subscribe-btn-label">SUBSCRIBE</span>
                <span class="subscribe-btn-prices">
                  $${price} <span class="compare-at">$${compareAtPrice}</span>
                </span>
              `;
              subscribeBtn.disabled = false;
            }, 2000);
            return;
          }
          
          window.cart.get().then((data) => {
                      if (window.state) {
              window.state.cart = data;
            }
            
            if (typeof window.trigger === 'function') {
              window.trigger('mini-cart-open', document.body, data);
            }
            
            subscribeBtn.innerHTML = `
              <span class="subscribe-btn-label">ADDED!</span>
              <span class="subscribe-btn-prices">
                $${price} <span class="compare-at">$${compareAtPrice}</span>
              </span>
            `;
            setTimeout(() => {
              subscribeBtn.innerHTML = `
                <span class="subscribe-btn-label">SUBSCRIBE</span>
                <span class="subscribe-btn-prices">
                  $${price} <span class="compare-at">$${compareAtPrice}</span>
                </span>
              `;
              subscribeBtn.disabled = false;
            }, 1200);
          });
        });
      } else {
        
        // Prepare the request body for the fallback fetch method
        let requestBody;
        if (sellingPlanId) {
          // Use selling plan only (no properties to avoid showing on checkout)
          requestBody = `id=${variantId}&quantity=1&selling_plan=${sellingPlanId}`;
        } else {
          // No properties to avoid showing on checkout
          requestBody = `id=${variantId}&quantity=1`;
        }
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: requestBody
        })
        .then(res => {
          if (!res.ok) {
            throw new Error(`HTTP ${res.status}: ${res.statusText}`);
          }
          return res.json();
        })
        .then(data => {
          
          subscribeBtn.innerHTML = `
            <span class="subscribe-btn-label">ADDED!</span>
            <span class="subscribe-btn-prices">
              $${price} <span class="compare-at">$${compareAtPrice}</span>
            </span>
          `;
          setTimeout(() => {
            subscribeBtn.innerHTML = `
              <span class="subscribe-btn-label">SUBSCRIBE</span>
              <span class="subscribe-btn-prices">
                $${price} <span class="compare-at">$${compareAtPrice}</span>
              </span>
            `;
            subscribeBtn.disabled = false;
          }, 1200);
          
          setTimeout(() => {
            fetch(window.Shopify.routes.root + "cart.js")
              .then((response) => response.json())
              .then((cartData) => {
                if (typeof renderCart === 'function') {
                  renderCart(cartData);
                }
                
                const overlay = document.querySelector(".overlay");
                const miniCart = document.querySelector(".mini-cart");
                const miniCartFooter = document.querySelector("#shopify-section-footer");
                if (overlay && miniCart) {
                  overlay.classList.add("overlay--show");
                  miniCart.classList.add("mini-cart--show");
                  document.body.style.overflow = 'hidden';
                  if (miniCartFooter) {
                    miniCartFooter.style.display = "none";
                  }
                }
                document.dispatchEvent(new Event('cart:updated'));
              })
              .catch((err) => {
                // Cart update failed
              });
          }, 800);
        })
        .catch((error) => {
          subscribeBtn.innerHTML = `
            <span class="subscribe-btn-label">ERROR</span>
            <span class="subscribe-btn-prices">
              $${price} <span class="compare-at">$${compareAtPrice}</span>
            </span>
          `;
          setTimeout(() => {
            subscribeBtn.innerHTML = `
              <span class="subscribe-btn-label">SUBSCRIBE</span>
              <span class="subscribe-btn-prices">
                $${price} <span class="compare-at">$${compareAtPrice}</span>
              </span>
            `;  
            subscribeBtn.disabled = false;
          }, 2000);
        });
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  injectSubscribeSave();
  
  document.addEventListener('click', function(e) {
  
    if (e.target.closest('[data-drawer-toggle="cart"]') || 
        e.target.closest('.cart-toggle') ||
        e.target.closest('.header__cart')) {
      
      setTimeout(() => {
        cleanupCartSliderModules();
      }, 200);
    }
  });
  
  document.addEventListener('cart:updated', function() {
    setTimeout(() => {
      cleanupCartSliderModules();
    }, 100);
  });
  
  const observer = new MutationObserver((mutations) => {
    let shouldInject = false;
    
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        const targetElement = mutation.target;
        
        const isInCartArea = 
          targetElement.closest('.recommend-products-slider') ||
          targetElement.closest('.shipping-calculator') ||
          targetElement.closest('[data-drawer="cart"]') ||
          targetElement.closest('.drawer-cart') ||
          targetElement.closest('#cart-drawer') ||
          targetElement.closest('.cart-recommended-products') ||
          targetElement.closest('.cart-cross-sell') ||
          
          targetElement.classList.contains('product-cart-slider') ||
          Array.from(targetElement.classList || []).some(className => 
            className.includes('cart-product-recommend-slider')
          );
        
        if (!isInCartArea) {
          
          let hasCartNodes = false;
          if (mutation.addedNodes) {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.classList && (
                  node.classList.contains('product-cart-slider') ||
                  node.classList.contains('recommend-products-slider') ||
                  Array.from(node.classList).some(className => 
                    className.includes('cart-product-recommend-slider')
                  )
                )) {
                  hasCartNodes = true;
                }
              }
            });
          }
          
          if (!hasCartNodes) {
            shouldInject = true;
          }
        }
      }
    });
    
    if (shouldInject) {
      clearTimeout(window.subscribeInjectTimeout);
      window.subscribeInjectTimeout = setTimeout(() => {
        const unprocessedCards = document.querySelectorAll('.product-card:not([data-subscribe-processed])');
        if (unprocessedCards.length > 0) {
          injectSubscribeSave();
        }
      }, 300);
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
});